module.exports = __webpack_public_path__ + "img/C5.4c77b459.png";